module.exports = __webpack_public_path__ + "ups-logo.12272cc00e2b2351531e73e98f2d7d79.svg";